<ng-container [formGroup]="form">
    <fieldset 
        class="_relative _mb-4"
        [ngClass]="modifierClassname">
        <label 
            class="_inline-block _ml-2 _mb-1 _relative"
            [ngClass]="darkTheme ? '_text-white' : '_text-black'"
            [for]="fieldId">
            {{label}}
        </label>
        <div class="_relative">
            <input 
            [id]="fieldId"
            [formControlName]="fieldId"
            class="_input-squared _input-slim _px-2 _w-full" 
            [class._input-invalid]="type === 'set' && control?.invalid && control?.touched"
            [ngClass]="{ '_input-dark' : darkTheme, '_min-w-60' : useMinWidth }"
            [type]="passwordVisible ? 'text' : 'password'"
            [value]="value" 
            [placeholder]="placeholderText">
            <span 
                class="_absolute _h-full _w-4 _right-2 _top-0 _flex _justify-center _items-center _cursor-pointer"
                (click)="showPassword()">
                <i class="fa _text-md-m" [ngClass]="passwordVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
        </div> 

        <ng-container *ngIf="type === 'set'">
            <div class="_flex _gap-nudge-3 _mt-1">
                <div class="_h-nudge-4 _w-1/4" [ngClass]="matchCount > 1 ? darkTheme ? '_bg-white' : '_bg-primary-1' : darkTheme ? '_bg-transparency-white-25' : '_bg-primary-1-tint-20'"></div>
                <div class="_h-nudge-4 _w-1/4" [ngClass]="matchCount > 2 ? darkTheme ? '_bg-white' : '_bg-primary-1' : darkTheme ? '_bg-transparency-white-25' : '_bg-primary-1-tint-20'"></div>
                <div class="_h-nudge-4 _w-1/4" [ngClass]="matchCount > 3 ? darkTheme ? '_bg-white' : '_bg-primary-1' : darkTheme ? '_bg-transparency-white-25' : '_bg-primary-1-tint-20'"></div>
                <div class="_h-nudge-4 _w-1/4" [ngClass]="matchCount > 4 ? darkTheme ? '_bg-white' : '_bg-primary-1' : darkTheme ? '_bg-transparency-white-25' : '_bg-primary-1-tint-20'"></div>
            </div>
            <div class="_absolute _right-2 _text-xs _pt-1"
                [ngClass]="darkTheme ? '_text-white' : '_text-black'">
                {{passwordStrength}}
            </div>
            <div *ngIf="control?.invalid && control?.touched" class="_text-error-red-light _text-sm _mt-2 _ml-2" >
                <div [ngClass]="validations.lengthMatch ? darkTheme ? '_text-white' : '_text-black' : ''">At least 8 characters long.</div>
                <div [ngClass]="darkTheme ? '_text-white' : '_text-black'" class="_py-1 _italic _underline">And at least 3 of the following 4 conditions:</div>
                <ul class="_list-disc _pl-3">
                    <li [ngClass]="validations.upperCaseMatch ? darkTheme ? '_text-white' : '_text-black' : ''">At least one uppercase letter.</li>
                    <li [ngClass]="validations.lowerCaseMatch ? darkTheme ? '_text-white' : '_text-black' : ''">At least one lowercase letter.</li>
                    <li [ngClass]="validations.digitMatch ? darkTheme ? '_text-white' : '_text-black' : ''">At least one digit.</li>
                    <li [ngClass]="validations.specialCharacterMatch ? darkTheme ? '_text-white' : '_text-black' : ''">At least one special character.</li>    
                </ul>
            </div>
        </ng-container>
    </fieldset>
</ng-container>
